<template>
  <transition name="fade">
    <div class="page">
    <div class="secondary-header" v-if="ready && !embeded">
        <div @click="() => { this.$router.push({path: '/channels'})}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
           Channels
        </div>

        <div class="save" v-ripple @click="save">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="this.channel.saved ? 'saved' : ''">
                <path d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>


      <div class="sports-wrapper" v-if="ready">
          <div class="logo" ref="logo">
            <img ref="img" class="channel-logo" :class="{tfs: channel.country === '24/7'}" :src="channel.asset.img" v-if="channel.asset && channel.asset.img" loading="lazy" />
            <img ref="img" class="channel-logo" :class="{tfs: channel.country === '24/7'}" src="https://cdn.pixabay.com/photo/2016/03/31/18/39/generic-1294538_1280.png" v-if="!channel.asset || !channel.asset.img" loading="lazy" />

            <div class="streamhead" v-if="channel.country == '24/7'">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"> <path d="M2 20.01L2.01 19.9989" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4C2.89543 4 2 4.89543 2 6V7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 16C4 16.5 5.5 18 6 20" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 12C6 12.5 9.5 16 10 20" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    LIVE STATION
                </div>
                <h3 ref="name"> {{channel.name}} </h3>
            </div>

            <div class="details"  v-if=" channel.country !== '24/7'">
                <h3 ref="name"> {{channel.name}} </h3>
                <h3 ref="name"> {{channel.group}} </h3>
            </div>
            <div class="info">
                <div class="badges">
                    <div class="country-badge" v-if="channel.country && channel.country !== '24/7'">
                        <img v-if="channel.country == 'USA'" src="https://flagicons.lipis.dev/flags/4x3/um.svg" loading="lazy"/>
                        <img v-if="channel.country == 'CA'" src="https://flagicons.lipis.dev/flags/4x3/ca.svg" loading="lazy"/>
                        <img v-if="channel.country == 'UK'" src="https://flagicons.lipis.dev/flags/4x3/gb.svg" loading="lazy"/>
                    </div>
                </div>
            </div>
          </div>

            <div class="stream-wrapper" >
                <h3> Streams </h3>
                <div class="streams">
                    <div v-for="(s,i) in channel.links" :key="i" v-ripple class="stream" @click="play(s.link)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M6.90588 4.53682C6.50592 4.2998 6 4.58808 6 5.05299V18.947C6 19.4119 6.50592 19.7002 6.90588 19.4632L18.629 12.5162C19.0211 12.2838 19.0211 11.7162 18.629 11.4838L6.90588 4.53682Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        {{s.name}}
                    </div>
                </div>
            </div>


            <div v-if=" channel.country !== '24/7'">

                <div class="section" v-if="ready && epgs.length > 0">
                    <div class="content">
                        <h3>  Guides </h3>
                    </div>
                </div>

                <div class="content no-guides" v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M8.5 14C8.22386 14 8 13.7761 8 13.5C8 13.2239 8.22386 13 8.5 13C8.77614 13 9 13.2239 9 13.5C9 13.7761 8.77614 14 8.5 14Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15.5 14C15.2239 14 15 13.7761 15 13.5C15 13.2239 15.2239 13 15.5 13C15.7761 13 16 13.2239 16 13.5C16 13.7761 15.7761 14 15.5 14Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10 18H14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    no channel guides available
                </div>
            </div>

            <div class="content-row" v-for="(e,i) in epgs" :key="i">
                <ListGuide :guide="e" v-ripple/>
            </div>


            <div class="section ota" v-if="ready && mainEPG.schedule.length > 0">
                <div class="content">
                    <h3>  On The Air </h3>
                </div>
            </div>

            <div class="section" v-if="ready && mainEPG.schedule.length > 0">
                <div class="schedule">
                    <div class="item" v-for="(e, i) in mainEPG.schedule" :key="i" :style="getHeight(e)">
                        <div class="details">
                            <p> {{ e.name }} </p>
                            <span>
                                {{getTime(e.start)}} - {{getTime(e.end)}}
                            </span>

                        </div>
                    </div>
                </div>
            </div>


            <div class="section" :class="{'content-g': channel.country == '24/7'} ">
                <div class="content">
                    <h3> More like {{ channel.name }} </h3>
                  </div>
              </div>
           </div>

          <div class="content-row related" >
              <div v-for="(c,i) in channel.related" :key="i + c.id">
                  <Channel v-ripple :channel="c"/>
              </div>
          </div>

    </div>
  </transition>
</template>

<script>
import ListGuide from '../components/ListGuide.vue';

const Channel  = () => import('@/components/Channel')

export default {
  name: 'ChannelView',

  components: {
    Channel,
    ListGuide
  },

  props: {
        embeded: Boolean,
        detailsOnly: Boolean,
        contentId: Number,
  },

  watch: {
      $route() {
        this.load()
        this.$nextTick(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        })
      }
  },

  data: function(){
    return {
        channel: {},
        mainEPG: {
            schedule: []
        },
        epgs: [],
        ready: false,
    }
  },

  methods: {

    async save(){
        let data = {
            type: 'live',
            id: `${this.channel.id}`,
            ref: `${window.location.origin}/channel/${this.channel.id}`,
            name: this.channel.name,
            imgs: [this.channel.asset.img],
            color: window.getAssetColor(this.channel.asset),
        }

        const req = await window.afetch(`/save`, {method: 'POST', body: JSON.stringify(data) })
        const res = await req.json()
        this.channel.saved = res.saved
    },

    play(url){
        if(!window.did){
            this.$root.$emit('collectDid', {cb: this.play.bind(this),
                params: {
                    url: url,
                    title: this.channel.name,
                    artwork: this.channel.asset ? this.channel.asset.img : ''
                }
            })
            return
        }

        const logo = []
        if(this.channel.asset){ logo.push(this.channel.asset.img) }

        const data = {
            type: 'live',
            id: `${this.channel.id}`,
            did: window.did,
            url: url,
            ref: `${window.location.origin}/channel/${this.channel.id}`,
            name: this.channel.name,
            logos: logo,
            color: window.getAssetColor(this.channel.asset),
            details: {country: this.channel.country}
        }

        window.afetch(`/start`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { "Content-Type": "application/json" }
        })
    },

    getHeight(e){
        if(e){
            const pixelsPerHour = 100;

            const start = new Date(e.start);
            const end = new Date(e.end);

            const currentTime = window.now;

            if (end <= currentTime) { return {display: 'none'}; }

            const duration = end.getTime() - start.getTime();
            const hours = duration / (1000 * 60 * 60);
            const height = hours * pixelsPerHour;
            return {height: height + 'px'};

        }
    },

    getTime(time){ return window.getTime(time) },

    getEPGLink(arr) {
        const frequencyMap = {};

        // Count the occurrences of each string
        arr.forEach((str) => {
            if (frequencyMap[str.epg]) {
                frequencyMap[str.epg]++;
            } else {
                frequencyMap[str.epg] = 1;
            }
        });

        // Find the string with the highest frequency
        let mostCommonString = null;
        let highestFrequency = 0;

        for (const str in frequencyMap) {
            if (frequencyMap[str] > highestFrequency) {
                mostCommonString = str;
                highestFrequency = frequencyMap[str];
            }
        }

        return mostCommonString;
    },

    getUniqueStrings(arr) {
        const newArr = arr.map(item => item.epg);
        const uniqueStrings = [...new Set(newArr)];
        return uniqueStrings;
    },

    async loadEPG(){
        const epgID = this.getEPGLink(this.channel.links)
        const epgIDs = this.getUniqueStrings(this.channel.links)

        if(epgID){
            const epgReq = await window.afetch(`/guide?id=${epgIDs.join(',')}`)
            const data = await epgReq.json()
            this.epgs = data.channels
            const schedule = []
            this.mainEPG = this.epgs.find((e) => { return e.id == epgID })

            if(this.mainEPG){
                for(const x of this.mainEPG.schedule){
                    if(schedule.length < 5){
                        const h = this.getHeight(x)
                        if(h.display != 'none'){
                            schedule.push({...x, height: h})
                        }
                    }
                }
                this.mainEPG.schedule = schedule
            }else{
                this.mainEPG = {schedule: []}
            }
        }
    },

    async load(){
        this.ready = false;
        const req = await window.afetch(`/channel?id=${this.id}`)
        const data = await req.json()
        this.channel = data
        this.setTab()
        this.$nextTick(async () => {
            await this.loadEPG()
            this.$nextTick(() => {
                this.ready = true

                this.$nextTick(() => {
                    this.$refs.logo.style.background = window.getAssetColor(this.channel.asset)
                })
            })
        })
    },

    setTab(){
        if(!this.embeded){
            document.title = `Watch ${this.channel.name} Live - QB`
        }

    }
  },

  computed: {
        id(){
            if(this.contentId){
                return this.contentId
            }
            return this.$route.params.id
        }

  },

  mounted: function(){
    this.load()
  },

  activated: function(){
    this.setTab()
  }
}

</script>

<style scoped lang="scss">
.content-row {
    padding-left: 0;
}
.sports-wrapper{
    > div:not(.stream-wrapper){
        padding-left: 20px;
        padding-right: 20px;
    }
    .stream-wrapper h3{
        padding-left: 20px;
    }

    .badges{
        display: flex;
        >div{
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 2px solid white;
            margin-right: 10px;
            font-size: 9px;
            font-weight: bold;
            overflow: hidden;

            &.quality-badge{
                background-color: black;
            }

            img{
                width: 110%;
                height: 110%;
                object-fit: cover;
            }
        }
    }

    .logo{
        width: 100%;
        overflow: hidden;
        background-color: rgb(144, 144, 144);
        height: 250px;
        z-index: 0;
        padding: 10px 0;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
        position: relative;
        box-sizing: border-box;
        .details{
            position: absolute;
            width: 75%;
            display: flex;
            bottom: 20px;
            left: 20px;
            text-align: left;
            h3{
                padding: 0;
                text-transform: uppercase;
                letter-spacing: 2px;
                margin-right: 10px;
                color: white;
                font-size: 9px;
            }
        }
        .channel-logo{
            max-height: 75px;
            max-width: 50vw;
            padding-top: 75px;
            &.tfs{
                max-width: none;
                max-height: none;
                position: absolute;
                width: 100%;
                top: 0;
                padding: 0;
                left: 0;
                opacity: 0.5;
            }
        }
    }
}

.content-row{
   width: 100%;
   margin: 20px 0;
   padding-left: 20px;

}
.streams{
    display: flex;
    flex-direction: row;
    margin:20px 0;
    margin-bottom: 30px;
    padding-left: 20px;
    overflow-x: scroll;
    align-items: center;
    height: 75px;
    svg{
        height: 15px;
        margin-bottom: 10px;
        margin-top: 5px;
    }

    .stream{
        font-size: 9px;
        border: 1px solid white;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #111;
        margin-right: 10px;
        padding: 5px 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        min-width: 100px;
        overflow: hidden;
        text-align: center;
    }
}

.info{
    position: absolute;
    right: 20px;
    bottom: 20px;
    z-index: 1;
    position: absolute;
    justify-content: flex-start;
}

.ota{
    margin-top: 40px
}

.schedule{
  padding: 10px;
  padding-bottom: 20px;
 .item{
    border-left: 1px solid white;
    padding-left: 10px;
    margin-left: 10px;
    min-height: 55px;
    max-height: 300px;

    p{
        margin-bottom: 0;
    }
    span{
        font-size: 10px
    }
 }
}

.content-row.related {
    > div:last-of-type{
        padding-right: 40px;
    }
}
.content-g{
    padding-top: 60px;
}

.no-guides{
    margin: 20px 0;
    padding: 10px;
    width: 100%;
    margin: 0 auto;
    border: 1px solid white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    flex-direction: column;
    font-size: 11px;
    svg{
        padding-bottom: 10px
    }

}

.streamhead{
    position: absolute;
    top: 80px;
    left: 20px;
    width: 80%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    h3{
        padding-top: 20px;
        font-size: 26px;
    }
    > div{
        font-size: 9px;
        display: flex;
        align-items: center;
        flex-grow: 1;


        svg{
            width: 15px;
            padding-right: 10px;
        }

    }

}
</style>
